
export default function Introduction() {
  return (
    <section className="py-14 bg-[#E8740C]">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <p className="text-white text-base md:text-lg leading-relaxed font-body">
          <strong>New Generation Welding &amp; Fabrication</strong> is the welding contractor that general contractors, builders, and project managers trust for <strong>structural steel welding</strong>, custom metal fabrication, and heavy equipment repair. From AG equipment to ornamental ironwork — if you can envision it, we can build it.
        </p>
      </div>
    </section>
  );
}
